import { createSlice } from "@reduxjs/toolkit";
import {
  getAIChats,
  createAIChat,
  renameAIChat,
  deleteAIChat,
  getHelpSupportUnread,
} from "./AIChatActions";

const initialState = {
  loading: false,
  items: [],
  meta: null,
  error: null,
  // [CANA-718] Support answers in help threads the user has not opened yet. Since
  // [CANA-752] the count also includes automatic answers delivered after a deploy; the
  // name stays because the endpoint path (ai/help/support/unread/) did not change.
  supportUnread: { count: 0, chatIds: [] },
};

const aiChatSlice = createSlice({
  name: "aiChats",
  initialState,
  reducers: {
    resetAIChatError: (state) => {
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getAIChats.pending, (state) => {
        state.loading = true;
      })
      .addCase(getAIChats.fulfilled, (state, action) => {
        if (action.payload.page > 1) {
          state.items = [...state.items, ...(action.payload.results || [])];
        } else {
          state.items = action.payload.results || [];
        }
        state.meta = action.payload.meta || null;
        state.loading = false;
      })
      .addCase(getAIChats.rejected, (state, action) => {
        state.error = action.payload;
        state.loading = false;
      })
      .addCase(createAIChat.fulfilled, (state, action) => {
        state.items = [action.payload, ...state.items];
        if (state.meta) state.meta.count = (state.meta.count || 0) + 1;
      })
      .addCase(createAIChat.rejected, (state, action) => {
        state.error = action.payload;
      })
      .addCase(renameAIChat.fulfilled, (state, action) => {
        state.items = state.items.map((chat) => {
          if (chat.id === action.payload.id) {
            return { ...chat, title: action.payload.title };
          }
          return chat;
        });
      })
      .addCase(renameAIChat.rejected, (state, action) => {
        state.error = action.payload;
      })
      .addCase(deleteAIChat.fulfilled, (state, action) => {
        state.items = state.items.filter(
          (chat) => chat.id !== action.payload.id
        );
        if (state.meta) state.meta.count = Math.max(0, (state.meta.count || 0) - 1);
      })
      .addCase(deleteAIChat.rejected, (state, action) => {
        state.error = action.payload;
      })
      // A failed check keeps the last known state: the dot is a hint, and clearing it
      // on a network blip would hide an answer the user is waiting for.
      .addCase(getHelpSupportUnread.fulfilled, (state, action) => {
        state.supportUnread = {
          count: action.payload?.unread || 0,
          chatIds: action.payload?.chat_ids || [],
        };
      });
  },
});

export const { resetAIChatError } = aiChatSlice.actions;
export default aiChatSlice.reducer;
